class DynamicSiteLogo {
    constructor() {
        this.body = document.querySelector("body");
        this.header = document.querySelector("header");
        this.logo = document.querySelector("img.custom-logo");

        // WordPress Customizer settings
        this.darkLogo = wpApiSettings.dark_logo;
        this.lightLogo = wpApiSettings.light_logo;

        this.init();
    }

    init() {
        if (
            this.body.classList.contains('page-template-text')
            || this.body.classList.contains('page-template-wide')
        ) {
            this.header.classList.add("header__always-dark");
            this.showDarkLogo();
        }

        window.addEventListener("scroll", () => this.changeHeader());
    }

    changeHeader() {
        this.scrollPos = window.scrollY;

        if (this.scrollPos > 200) {
            this.header.classList.add("header__sticky");
            this.showDarkLogo();
        } else {
            this.header.classList.remove("header__sticky");
            this.showLightLogo();
        }
    }

    showDarkLogo() {
        if (!this.logo.getAttribute('src').includes(this.darkLogo)) {
            this.logo.srcset = '';
            this.logo.src = this.darkLogo;
        }

        this.header.classList.remove("header__light");
        this.header.classList.add("header__dark");
    }

    showLightLogo() {
        if (this.header.classList.contains('header__always-dark')) return;

        if (!this.logo.getAttribute('src').includes(this.lightLogo)) {
            this.logo.srcset = '';
            this.logo.src = this.lightLogo;
        }

        this.header.classList.remove("header__dark");
        this.header.classList.add("header__light");
    }
}

export default DynamicSiteLogo;